module.exports = __webpack_public_path__ + "static/media/newsletter.9886853c.svg";